// extracted by mini-css-extract-plugin
export default {"dropIndicator":"dropIndicator--vQ45z"};